import React from 'react';

/**
 * Brand-safe bar chart icon — Green + Gold (no blue).
 * Replaces the 📊 emoji across the app (which ships with platform-blue bars
 * that clash with the Green/Gold/Black palette).
 *
 * Size defaults to 1em so it inlines nicely in headings.
 */
export default function BarChartIcon({ size = '1em', className = '' }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      className={`inline-block align-[-0.15em] ${className}`}
      aria-hidden="true"
    >
      {/* Baseline */}
      <line x1="3" y1="20" x2="21" y2="20" stroke="#888" strokeWidth="1.5" strokeLinecap="round" />
      {/* Short green bar */}
      <rect x="5" y="14" width="3.5" height="6" rx="0.5" fill="#00D26A" />
      {/* Medium green bar */}
      <rect x="10.25" y="10" width="3.5" height="10" rx="0.5" fill="#00D26A" />
      {/* Tallest bar — GOLD (the "best" outcome) */}
      <rect x="15.5" y="5" width="3.5" height="15" rx="0.5" fill="#FFD700" />
    </svg>
  );
}
